import React from 'react';
import { faTimes, faSave, faTimesCircle, faCheckCircle, faUpload, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { LessonStateDto } from '../../../../api-service/clients';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';

interface ILessonLaunchboxProps {
  onSave: () => void;
  onValidate: () => boolean;
  onCancelLesson: () => void;
  onDeleteLesson: () => void;
  isLoading: boolean;
  isReadOnly: boolean;
  canOpenProtocol: boolean;
  lessonState: LessonStateDto;
  onOpenProtocol: () => void;
  onPublishLesson: () => void;
}

export function LessonLaunchbox(props: ILessonLaunchboxProps) {
  const { isLoading, onSave, onValidate, onCancelLesson, isReadOnly, canOpenProtocol, lessonState, onOpenProtocol, onDeleteLesson, onPublishLesson } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  const isDraft = lessonState === LessonStateDto.Draft;

  return (
    <FloatingActionButtonBar>
      {!isReadOnly && (
        <>
          <FloatingActionButton buttonText="Aflys" icon={faTimesCircle} onClick={onCancelLesson} />
          <FloatingActionButton buttonText="Slet" icon={faTrashCan} onClick={onDeleteLesson} />
        </>
      )}
      {canOpenProtocol && <FloatingActionButton buttonText="Protokol" icon={faCheckCircle} onClick={onOpenProtocol} />}
      {!isReadOnly && (
        <>
          <FabDivider />
          <FloatingActionButton buttonText="Gem og luk" icon={faSave} onClick={handleSave} inverted loading={isLoading} />
          {isDraft && <FloatingActionButton buttonText="Publicér" icon={faUpload} inverted onClick={onPublishLesson} loading={isLoading} />}
        </>
      )}
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
